import * as React from 'react';
import { pagesCalculator } from './paging-calculate';
import { PagingStore } from '../../../store/paging-store/paging-store';
import { observer } from 'mobx-react';
import DoubleChevronLeftSVG from '../../../assets/icons/double-chevron-left';
import DoubleChevronRightSVG from '../../../assets/icons/double-chevron-right';
import { ONE } from '../../../constans/common-constants';
import './paging.scss';

interface IProps {
    pagingStore: PagingStore;
    onSelectPageCallback?: () => void;
}

const PagingPages: React.FC<IProps> = ({ pagingStore, onSelectPageCallback }): JSX.Element => {
  const {
    getTotalPages,
    getCurrentPage,
    prev,
    next,
    selectPage
  } = pagingStore;

  const currentPage = getCurrentPage();
  const totalPages = getTotalPages();
  const numbersOfPages = pagesCalculator(totalPages, currentPage);
  const prevButtonClass = 'change-page-btn prev-radius' + (currentPage === ONE || !totalPages ? ' disabled' : '');
  const nextButtonClass = 'change-page-btn next-radius' + (currentPage === totalPages || !totalPages ? ' disabled' : '');

  const selectPageHandler = (pageNumber: number): void => {
    selectPage(pageNumber);
    if(onSelectPageCallback) onSelectPageCallback();
  };

  return <div className='pagination-count'>
    <span className={prevButtonClass} onClick={prev}>{<DoubleChevronLeftSVG/>} Prev</span>
    {numbersOfPages.map((item, index) => {
      const pageNumberClass = 'pagination-page-number' + (currentPage === item ? ' current' : '');
      return item !== +item
        ? <span className='disabled' key={index}>{item}</span>
        : <span className={pageNumberClass} onClick={() => selectPageHandler(item) } key={index}>{item}</span>;
    })}
    <span className={nextButtonClass} onClick={next}>Next {<DoubleChevronRightSVG/>}</span>
  </div>;
};

export default observer(PagingPages);